<template>
    <div class="lms__user_invitation">
        <div class="lms__user_invitation_main">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-6">
                        <component-box
                            :title="titleOutput"
                            :content="contentOutput"
                            :button-active="!isUserLoggedIn"
                            :button-text="$t('lms.user.account.invitation.button.signIn')"
                            :to="{ name: 'auth-login' }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentBox from '@/components/default/shared/ComponentBox'
export default {
  name: 'lms-user-invitation',
  components: { ComponentBox },
  computed: {
    routeQueryInvitationType () {
      return this.$route.query.type
    },
    routeQueryInvitationId () {
      return this.$route.query.invitation
    },
    isRouteError () {
      const routeName = this.$route.name
      return routeName.includes('error')
    },
    isRouteReject () {
      const routeName = this.$route.name
      return routeName.includes('reject')
    },
    isRouteAccept () {
      const routeName = this.$route.name
      return routeName.includes('accept')
    },
    isRouteResolved () {
      const routeName = this.$route.name
      return routeName.includes('resolved')
    },
    isUserLoggedIn () {
      return this.$store.getters.getAuthUserFirstStageTokenData
    },
    //
    titleOutput () {
      let titleSuffix
      if (this.isRouteError) {
        titleSuffix = 'error'
      } else if (this.isRouteReject) {
        titleSuffix = 'rejected'
      } else if (this.isRouteAccept) {
        titleSuffix = 'accepted'
      } else if (this.isRouteResolved) {
        titleSuffix = 'resolved'
      }
      return `${this.$t('lms.user.account.invitation.title')} ${titleSuffix}`
    },
    contentOutput () {
      let content
      if (this.isRouteError) {
        content = `${this.$t('lms.user.account.history.invitation.someIssues')} ${this.routeQueryInvitationType} ${this.$t('lms.user.account.history.invitation.contentPlease')}`
      } else if (this.isRouteReject) {
        content = this.$t('lms.user.account.history.invitation.rejected')
      } else if (this.isRouteAccept) {
        content = this.$t('lms.user.account.history.invitation.accepted')
      } else if (this.isRouteResolved) {
        content = this.$t('lms.user.account.history.invitation.already')
      }
      return content
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/invitation/lmsuserinvitation";
</style>
